// The Historical tab of the Clients accordion, on each dashboard that
// renders it. Separate events from the Active tab because selecting a tab
// is what tells them apart, and only the mounted dashboard can answer.
export const HISTORICAL_CLIENT_HOME_SECTION_EVENT =
	'canvas-agent:historical-client:home-section';
export const HISTORICAL_CLIENT_SITE_SECTION_EVENT =
	'canvas-agent:historical-client:site-section';
export const HISTORICAL_CLIENT_AP_SECTION_EVENT =
	'canvas-agent:historical-client:ap-section';
export const HISTORICAL_CLIENT_FILTER_EVENT =
	'canvas-agent:historical-client:filter';
